import ContactForm from "./components/website/contactForm";
import { sendEventToAnalytics } from "./helpers/common-helpers";

window.addEventListener('DOMContentLoaded', () => {
    new ContactForm();
});

window.addEventListener('load', () => {
    const contactPage = document.getElementById('contact-page');

    if (contactPage) {
        sendEventToAnalytics('open_form_contact');
    }
});
